const Step3 = () => {
  return <div>step 3</div>;
};

export default Step3;
